import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-14d90ce6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-invalid"
};
export function render(_ctx, _cache) {
  const _component_van_empty = _resolveComponent("van-empty");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_empty, null, {
    description: _withCtx(() => [_createTextVNode(" 没有正在进行中的行程或行程已过期 ")]),
    _: 1
  })]);
}